import React from "react";

import Select from "antd/es/select";
import { useIntl } from "react-intl";

import { StandardRange } from "@mapmycustomers/shared/types/range/DateRange";

import useQuarterOptions from "@app/component/input/dateRangeSelect/utils/useQuarterOptions";
import SelectField from "@app/component/input/SelectField";

interface Props {
  className?: string;
  fromDate?: Date;
  label?: React.ReactNode;
  onChange?: (value?: StandardRange) => void;
  value: StandardRange;
}

const QuarterSelect: React.FC<Props> = ({ className, fromDate, label, onChange, value }) => {
  const intl = useIntl();
  const quarters = useQuarterOptions(intl, fromDate);

  return (
    <SelectField<StandardRange>
      className={className}
      dropdownMatchSelectWidth={false}
      label={
        label ??
        intl.formatMessage({
          id: "dateRangeSelect.quarter",
          defaultMessage: "Select quarter",
          description: "Quarter field label in range selector component",
        })
      }
      onChange={onChange}
      optionFilterProp="children"
      showSearch
      value={value}
    >
      {quarters.map((quarterGroup) => {
        return (
          <Select.OptGroup key={quarterGroup.key} label={quarterGroup.label}>
            {quarterGroup.options.map((range) => (
              <Select.Option key={range.value} value={range.value}>
                {range.label}
              </Select.Option>
            ))}
          </Select.OptGroup>
        );
      })}
    </SelectField>
  );
};

export default QuarterSelect;
